import { render, staticRenderFns } from "./JsryzxwhEdit.vue?vue&type=template&id=6bfe61ff"
import script from "./JsryzxwhEdit.vue?vue&type=script&lang=js"
export * from "./JsryzxwhEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports